import { DeliveryOrderService } from './../../../../transport-operation/services/delivery-order.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { EventEmitter, Injector, Input, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DailyRateService } from '../../../service/daily-rate.service';

@Component({
  selector: 'laas-daily-rate-setting-import',
  templateUrl: './daily-rate-setting-import.component.html',
  styleUrls: ['./daily-rate-setting-import.component.scss']
})
export class DailyRateSettingImportComponent extends SessionBaseComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() visibleChange: EventEmitter<any>;
  @Output() uploadClick: EventEmitter<any>;

  readonly preferenceKey: string;
  dailyRateRows: any[];
  rateType: any;
  importForm: FormGroup;
  rateTypeOptions: any[];
  currencyOptions: any[];
  isLoading: boolean;
  isVisible: boolean;
  columns: any[];

  constructor(
    injector: Injector,
    private commonDataService: CommonDataService,
    private DOService: DeliveryOrderService,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private dailyRateService: DailyRateService
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.DailyRateSettingImport;
    this.dailyRateRows = [];
    this.rateType = 'CUSTOMS';
    this.rateTypeOptions = [];
    this.currencyOptions = [];
    this.isLoading = false;
    this.isVisible = false;
    this.visibleChange = new EventEmitter<any>();
    this.uploadClick = new EventEmitter<any>();

    this.columns = [
      { field: 'date', header: 'ExchangeRateImport.Date', dataType: 'date', sort: true },
      { field: 'rateYM', header: 'ExchangeRateImport.ExchangeRateRange', sort: true },
      { field: 'fromCurrency', header: 'ExchangeRateImport.OriginCurrency', sort: true },
      { field: 'toCurrency', header: 'ExchangeRateImport.ConversionCurrency', sort: true },
      { field: 'rate', header: 'ExchangeRateImport.ExchangeRate', sort: true },
    ];

    this.importForm = this.formBuilder.group({
      rateType: 'CUSTOMS'
    });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }
  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RateType').subscribe({
      next: result => {
        this.rateTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.currencyOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });
  }



  fileUploader(event: any): void {
    this.isLoading = true;
    if (event.files[0]) {
      console.log('true');
    } else {
      console.log('false');
    }
    this.dailyRateService.importDailyRateByExcel(event.files[0], this.laasSetting.facility, this.userProfile.userName).subscribe({
      next: result => {
        this.dailyRateRows = result;
      },
      complete: () => {
        this.clearUploadUI();
        this.isLoading = false;
      }
    });
  }

  clearUploadUI(): void {
    this.fileUpload.clear();
  }

  importClickBtn(event: any): void {
    if (this.dailyRateRows.some(x => x.CONVERSION_YM === null)) {
      this.toastService.warn(this.translateService.instant('ExchangeRate.Alert.ExchangeRateRangeBlank'));
      return;
    }
    if (this.dailyRateRows.some(x => x.FROM_CURRENCY === null)) {
      this.toastService.warn(this.translateService.instant('ExchangeRate.Alert.OriginCurrencyBlank'));
      return;
    }
    if (this.dailyRateRows.some(x => x.TO_CURRENCY === null)) {
      this.toastService.warn(this.translateService.instant('ExchangeRate.Alert.CoversionCurrencyBlank'));
      return;
    }
    if (this.dailyRateRows.some(x => x.CONVERSION_RATE === null)) {
      this.toastService.warn(this.translateService.instant('ExchangeRate.Alert.ExchangeRateBlank'));
      return;
    }

    this.dailyRateRows.forEach(x => {
      x.rateType = this.rateType != null ? this.rateType : x.rateType;
      x.isActivated = '1';
      this.dailyRateService.addDailyRate(x).subscribe({
        next: result => {
          this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
              }
            });
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
    });
    this.dailyRateRows = [];
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }

  templateDownloadClickBtn(event: any): void {
    this.commonDataService.getSystemParam('DaliyRateSetting').subscribe({
      next: result => {
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };

        this.DOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' }); // application後面接下載的副檔名

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = `DailyRate_Sample.xlsx`;
          link.click();
        });
      }
    });
  }
}
